import QuizLayout from "@/layouts/QuizLayout.vue";
export default {
  path: '/',
  component: QuizLayout,
  children: [
    {
      path: '/compliance-training/:training_id/terms',
      name: 'workspaces-training-terms',
      component: () => import('@/views/dashboard/workspaces/_id/compliance-training/terms.vue'),
      meta: {
        title: 'Quiz Results',
        auth: true,
        permissions: { any: ['conduct_training'] }
      }
    },
    {
      path: '/workspaces/:workspace_id/compliance-training/:training_id/terms',
      redirect: (to) => ({
        name: 'workspaces-training-terms',
        params: { training_id: to.params.training_id },
      }),
    },
    {
      path: '/compliance-training/:training_id/quiz',
      name: 'workspaces-training-quiz',
      component: () => import('@/views/dashboard/workspaces/_id/compliance-training/quiz.vue'),
      meta: {
        title: 'Take Quiz',
        auth: true,
        permissions: { any: ['conduct_training'] }
      }
    },
    {
      path: '/compliance-training/:training_id/quiz/results',
      name: 'workspaces-training-quiz-results',
      component: () => import('@/views/dashboard/workspaces/_id/compliance-training/results.vue'),
      meta: {
        title: 'Quiz Results',
        auth: true,
        permissions: { any: ['conduct_training'] }
      }
    },
  ]
}
